import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

// ── Provider ──────────────────────────────────────────────
const SearchProvider = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;
    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) { params.append(key, value); paramCount++; }
    });
    let url = `${config.API_URL}/providers/search`;
    if (paramCount > 0) url += `?${params.toString()}`;
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetProviderById = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(`${config.API_URL}/providers/${id}`, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const CreateProvider = async (req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.post(`${config.API_URL}/providers`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const UpdateProvider = async (id, req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.put(`${config.API_URL}/providers/${id}`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const DeleteProvider = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.patch(`${config.API_URL}/providers/${id}`, JSON.stringify({ status: 0 }), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// ── Provider Branch ───────────────────────────────────────
const SearchProviderBranch = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;
    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) { params.append(key, value); paramCount++; }
    });
    let url = `${config.API_URL}/provider-branchs/search`;
    if (paramCount > 0) url += `?${params.toString()}`;
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetProviderBranchById = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(`${config.API_URL}/provider-branchs/${id}`, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const CreateProviderBranch = async (req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.post(`${config.API_URL}/provider-branchs`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const UpdateProviderBranch = async (id, req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.put(`${config.API_URL}/provider-branchs/${id}`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const DeleteProviderBranch = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.patch(`${config.API_URL}/provider-branchs/${id}`, JSON.stringify({ status: 0 }), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const ProviderService = {
    SearchProvider,
    GetProviderById,
    CreateProvider,
    UpdateProvider,
    DeleteProvider,
    SearchProviderBranch,
    GetProviderBranchById,
    CreateProviderBranch,
    UpdateProviderBranch,
    DeleteProviderBranch,
};

export default ProviderService;